// Temporary launch switch. Match Center remains available in the admin area
// and backend, but is hidden from every public tournament navigation.
export const MATCH_CENTER_PUBLIC_ENABLED = true;
